const GeometryType = Object.freeze({
  RECTANGLE: 'RECTANGLE',
  POLYGON: 'POLYGON',
  CIRCLE: 'CIRCLE'
})
export default GeometryType
// RESERVE BELOW
